<template>
  <div class="homeHeater maxWidth">
    <div class="homeHeater-left">
      <div class="logo">
        <img src="../assets/logo.png" alt="" />
      </div>
      <div class="menuList">
        <div class="" v-for="(item, index) in headerList" :key="index">
          <div
            class="menuList-item"
            @click="menuClick(item)"
            v-if="item.name != '产品介绍'"
          >
            <img
              v-if="'/' + $route.name == item.url"
              src="../assets/tuanyuan.png"
              alt=""
            />

            <router-link
              :class="{ active: '/' + $route.name == item.url }"
              :to="item.url"
              >{{ item.name }}</router-link
            >
          </div>
          <div class="menuList-item" @click="menuClick(item)" v-else>
            <img
              v-if="$route.name == command"
              src="../assets/tuanyuan.png"
              alt=""
            />

            <el-dropdown class="dropdownBox" @command="navClick">
              <router-link
                to="/productionManagement"
                class="el-dropdown-link"
                :class="{ active: $route.name == command }"
              >
                产品介绍<i class="el-icon-arrow-down el-icon--right"></i>
              </router-link>
              <el-dropdown-menu slot="dropdown">
                <router-link
                  :to="itemTitle.url"
                  v-for="(itemTitle, indexTitle) in item.list"
                  :key="indexTitle"
                >
                  <el-dropdown-item :command="itemTitle.url">{{
                    itemTitle.name
                  }}</el-dropdown-item>
                </router-link>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="homeHeater-right">
      <img src="../assets/photo.png" alt="" />
      <span>{{ tel }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "homeHeater",
  data() {
    return {
      show: 0,
      tel: "",
      command: "",
      headerList: []
    };
  },
  watch: {
    "$route.name"(val) {
      switch (val) {
        case "enterpriseWebsite":
        case "productionManagement":
        case "electronicCommerce":
        case "mobileTerminal":
          this.command = val;
          break;
      }
    }
  },
  mounted() {
    switch (this.$route.name) {
      case "homePage":
        this.show = 0;
        break;
      case "caseDetails":
      case "customerCase":
        this.show = 2;
        break;
      case "enterpriseWebsite":
      case "productionManagement":
      case "electronicCommerce":
      case "mobileTerminal":
        this.command = this.$route.name;
        this.show = 1;
        break;
      case "newsInformation":
      case "newsInformationDetails":
        this.show = 3;
        break;
      case "aboutUs":
        this.show = 4;
        break;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getHeader").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.headerList = res.data.data.header;
          console.log(this.headerList);
          this.tel = res.data.data.tel;
        }
      });
    },
    menuClick(item) {
      this.$route.name == item.url;
    },
    navClick(command) {
      console.log(command);
      this.command = command;
      this.$route.name == this.command;
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.homeHeater {
  width: 1920px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 70px;
  background: #fefefe;
  display: flex;
  justify-content: space-between;
  z-index: 999;
  box-shadow: 0px 0px 16px rgba(102, 72, 74, 0.1);
}
.homeHeater-left {
  padding-left: 320px;
  display: flex;
  align-items: center;
}
.homeHeater-left img {
  display: block;
  width: 144px;
  height: 44px;
  margin-right: 103px;
}
.homeHeater-left .menuList {
  display: flex;
}
.homeHeater-left .menuList .menuList-item {
  margin-right: 54px;
  position: relative;
}
.homeHeater-left .menuList .menuList-item img {
  display: block;
  width: 19px;
  height: 19px;
  position: absolute;
  top: -2px;
  left: -8px;
}
.homeHeater-left .menuList .menuList-item .sanjiao {
  display: block;
  width: 17px;
  height: 10px;
  position: absolute;
  top: 46px;
  left: 50%;
  margin-left: -10px;
}
.homeHeater-left .menuList a {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #192537;
  cursor: pointer;
}
.homeHeater-left .menuList .active {
  color: #dd3939;
}
.homeHeater-left .menuList .menuList-item:hover a {
  color: #dd3939;
}
.homeHeater-right {
  /* width: 252px; */
  height: 70px;
  background: linear-gradient(-90deg, #dc3939, #ff4242);
  padding: 0 25px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.homeHeater-right img {
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 11px;
}
.homeHeater-right span {
  line-height: 70px;
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
}
</style>
<style>
.el-dropdown-menu__item a {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #192537;
  cursor: pointer;
}
.el-dropdown-menu {
  left: 600px !important;
  top: 57px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeHeater.vue